import { Box, Button, Divider, Flex, HStack, IconButton, Image, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { Link as DefaultLink, useNavigate } from 'react-router-dom';
import { EmptyTable, LoadingTable } from '../../components';
import { FleetType, Fleets } from '../../enums';
import React, { useEffect } from 'react';
import { deleteFleet, fetchFleets } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { FiArrowLeft } from 'react-icons/fi';
import { GrRefresh } from 'react-icons/gr';
import { ToastContainer } from 'react-toastify';
import { fleetType } from '../../types';

export const ViewFleets = () => {

    const { fleets, is_deleting_fleet, is_loading_fleets } = useAppSelector(state => state.fleetReducer);

    const dispatch: AppDispatch = useAppDispatch();

    const navigate = useNavigate();

    const getFleetImage = (fleet: string) => {
        switch (fleet) {
            case FleetType.BICYCLE:
                return Fleets?.BICYCLE;
            case FleetType.SCOOTER:
                return Fleets?.SCOOTER;
            case FleetType.MINI_BAKKIE:
                return Fleets?.MINI_BAKKIE;
            case FleetType.BAKKIE:
                return Fleets?.BAKKIE;
            case FleetType.HALF_TRUCK:
                return Fleets?.HALF_TRUCK;
            case FleetType.FOUR_TONS_TRUCK:
                return Fleets?.FOUR_TONS_TRUCK;
            case FleetType.EIGHT_TONS_TRUCK:
                return Fleets?.EIGHT_TONS_TRUCK;
            case FleetType.VAN:
                return Fleets?.VAN;
        }
    };

    useEffect(() => {
        if(!fleets.length) dispatch(fetchFleets());
    }, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            // bg={useColorModeValue('gray.50', 'gray.800')}
            py={10}
        >
            <Stack>
                <Box
                    rounded={'lg'}
                    bg={useColorModeValue('white', 'gray.700')}
                    boxShadow={'lg'}
                    p={8}>
                    <Stack spacing={4}>
                        <HStack align={'center'} justifyContent={'space-between'}>
                            <HStack>
                                <IconButton variant={'ghost'} aria-label='go back' icon={<FiArrowLeft style={{ width: '24px', height: '24px' }} />} as={DefaultLink} to='/vehicles' />
                                <Text display={'flex'} fontSize={'lg'} fontWeight='medium' textAlign={'center'}>
                                    Fleets.
                                </Text>
                            </HStack>
                            <HStack>
                                <IconButton aria-label='refresh' icon={<GrRefresh />} onClick={() => dispatch(fetchFleets())} />
                                <Button colorScheme={'yellow'} as={DefaultLink} to={'/vehicles/fleets/add'}>Add Fleet</Button>
                            </HStack>
                        </HStack>
                        <Divider />
                        <Stack mb={3}>
                            <Text textAlign={'center'} fontSize={'lg'} color={'gray.600'}>
                                To enjoy all of our cool features ✌️
                            </Text>
                        </Stack>
                        <Stack>
                            {
                                fleets?.map((fleet: fleetType, index: number) => (
                                    <HStack key={index} justifyContent={'space-between'} alignItems={'flex-start'} style={{ alignItems: 'start !important' }} shadow={'md'} p={6} borderRadius={6} maxW={'600px'}>
                                        <HStack>
                                            <Image
                                                boxSize='100px'
                                                objectFit='contain'
                                                src={getFleetImage(`${fleet?.fleet_size}`)}
                                                alt={fleet?.fleet_size}
                                            />
                                            <Stack>
                                                <Text fontWeight={'bold'} textTransform={'capitalize'}>Fleet : <span>{fleet?.fleet_size}</span></Text>
                                                <Text fontSize={12} color={'gray.500'} mt={'0px !important'}>Fleet Amount : <span style={{ color: '#4caf50' }}>R{fleet?.fleet_amount}</span></Text>
                                                <Text fontSize={12} color={'gray.500'} mt={'0px !important'}>Per KM : <span style={{ color: '#4caf50' }}>R{fleet?.per_km}</span></Text>
                                                <Text fontSize={12} color={'gray.500'} mt={'0px !important'}>Loader Amount : <span style={{ color: '#4caf50' }}>R{fleet?.loader_amount}</span></Text>
                                                <Text fontSize={12} color={'gray.500'} mt={'0px !important'}>Description : <span>{fleet?.description}</span></Text>
                                            </Stack>
                                        </HStack>
                                        <HStack>
                                            <Button colorScheme={'teal'} size='sm' onClick={() => navigate(`/vehicles/fleets/${fleet?.fleet_id}/edit`)} >
                                                Edit
                                            </Button>
                                            <Button loadingText='Deleting..' isLoading={is_deleting_fleet} disabled={is_deleting_fleet} colorScheme={'red'} size='sm' onClick={() => dispatch(deleteFleet(`${fleet?.fleet_id}`))}>
                                                Delete
                                            </Button>
                                        </HStack>
                                    </HStack>
                                ))
                            }
                        </Stack>
                        {is_loading_fleets && !fleets.length && <LoadingTable />}
                        {!fleets.length && !is_loading_fleets && <EmptyTable title='Oops!' description='Your company does not have fleets.' />}
                    </Stack>
                </Box>
            </Stack>
            <ToastContainer />
        </Flex>
    );
};